export default "__VITE_ASSET__D3oY9SKw__"